import Portrait from "./Portrait.tsx";

import styles from '../../../index.module.less'
import {CallBox} from "./CallBox.tsx";
import {STitle} from "shj-components";
import React from "react";

export const Left = () => {
  return <div className={styles.callBox}>
    <div className={styles.callToolBox}>
      <STitle title={'通话信息'} style={{fontSize: 14, fontWeight: 600, marginBottom: 10}}/>
      <CallBox/>
    </div>
    <div className={styles.customerTagBox}>
      <STitle title={'客户画像'} style={{fontSize: 14, fontWeight: 600}}/>
      <Portrait/>
    </div>
  </div>
}